import { makeObservable, observable, action } from 'mobx'

/**
 * Class representing a collection of related Sprints for a monthly report.
 */
/**
 * Sprints manages a list of sprint IDs related to a timed subtask.
 *
 * @class Sprints
 * @param {Object} sprint - Raw sprint data; expected to have a `list` array of IDs.
 */
export class Sprints {
	list = []

	constructor(sprint = []) {
		// Ensure sprint.list is an array before mapping
		this.list = Array.isArray(sprint?.list)
			? sprint?.list.map((sprint) => sprint)
			: [] // Return an empty array if subtask.comments.list is not an array

		makeObservable(this, {
			list: observable,
			addSprint: action.bound,
			removeSprint: action.bound
		})
	}

	/**
	 * Adds a sprint ID to the list.
	 *
	 * @param {string} id - The sprint ID to add.
	 */
	addSprint(id) {
		this.list = this.list.concat([id])
	}

	/**
	 * Removes a sprint ID from the list.
	 *
	 * @param {string} id - The sprint ID to remove.
	 */
	removeSprint(id) {
		this.list = this.list.filter((sprintId) => sprintId !== id)
	}

	/**
	 * Replaces the entire list of sprint IDs.
	 *
	 * @param {Array<string>} newSprintIds - New array of sprint IDs.
	 */
	replaceSprintIds(newSprintIds) {
		this.list = newSprintIds
	}
}
